module.exports = __webpack_public_path__ + "static/img/404.88cfac8d.jpg";